import r from "../helpers/isAbsoluteURL.js";
import f from "../helpers/combineURLs.js";
function u(l, i, t) {
  let o = !r(i);
  return l && (o || t == !1) ? f(l, i) : i;
}
export {
  u as default
};
